export default __webpack_public_path__ + "static/media/handphone_without_words.fda3449e.png";